(() => {
  const launcher = document.getElementById('eo-contact-launcher');
  const dialog = document.getElementById('eo-contact-dialog');
  if (!launcher || !dialog || typeof dialog.showModal !== 'function') return;
  const frameHost = dialog.querySelector('.eo-contact-frame');
  let frame;
  let previousOverflow;
  const initializeHandler = () => {
    if (typeof window.jotformEmbedHandler === 'function') {
      window.jotformEmbedHandler("iframe[id='eo-contact-iframe']", 'https://form.jotform.com/');
    }
  };
  launcher.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (dialog.open) return;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    if (frame) return;
    frame = document.createElement('iframe');
    frame.id = 'eo-contact-iframe';
    frame.title = document.getElementById('eo-contact-title').textContent;
    frame.allow = 'geolocation; microphone; camera; fullscreen';
    frame.src = launcher.href;
    frameHost.appendChild(frame);
    if (typeof window.jotformEmbedHandler === 'function') {
      initializeHandler();
    } else {
      const handler = document.createElement('script');
      handler.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
      handler.async = true;
      handler.addEventListener('load', initializeHandler, { once: true });
      document.body.appendChild(handler);
    }
  });
  dialog.querySelector('.eo-contact-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    launcher.focus();
  });
})();
